function calculateTitleTextScale (titleTextHeight) {
  if (typeof titleTextHeight === 'undefined') {
    return 0
  } else {
    return titleTextHeight / 10
  }
}

export function calculateTextScale (boxSize, textSize, titleTextHeight, capAtTitleSize = false) {
  if (boxSize.width <= 0 || boxSize.height <= 0 ||
      textSize.width <= 0 || textSize.height <= 0) {
    return 0
  }

  const scaleToFitWidth = boxSize.width / textSize.width
  const scaleToFitHeight = boxSize.height / textSize.height

  if (capAtTitleSize) {
    return Math.min(scaleToFitWidth, scaleToFitHeight, calculateTitleTextScale(titleTextHeight))
  } else {
    return Math.min(scaleToFitWidth, scaleToFitHeight)
  }
}
